var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMapPointWave(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.001 22.0003C17.5238 22.0003 22.001 19.9856 22.001 17.5003C22.001 16.2337 20.838 15.0892 18.9664 14.2715C17.8243 16.3673 16.0827 18.1738 13.8705 19.1192C12.6814 19.6274 11.3205 19.6274 10.1315 19.1192C7.91925 18.1738 6.17764 16.3673 5.03556 14.2715C3.16393 15.0892 2.00098 16.2337 2.00098 17.5003C2.00098 19.9856 6.47813 22.0003 12.001 22.0003Z",
    fill: "#5A5A5A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.00098 8.51464C5.00098 4.9167 8.13498 2 12.001 2C15.867 2 19.001 4.9167 19.001 8.51464C19.001 12.0844 16.7668 16.2499 13.281 17.7396C12.4685 18.0868 11.5335 18.0868 10.7209 17.7396C7.23514 16.2499 5.00098 12.0844 5.00098 8.51464ZM12.001 11C13.1055 11 14.001 10.1046 14.001 9C14.001 7.89543 13.1055 7 12.001 7C10.8964 7 10.001 7.89543 10.001 9C10.001 10.1046 10.8964 11 12.001 11Z",
    fill: "#5A5A5A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapPointWave);
export default __webpack_public_path__ + "static/media/mapPointWave.a65442e08315c8b5dc008796661e5f6a.svg";
export { ForwardRef as ReactComponent };